import { Button } from '@mantine/core';
import { CSSProperties } from 'react';
import { skyLighter } from '../../../../styles/design-tokens';
import { Icon } from '../../../../ui-library/icon/icon';

function SmallSquareButton({
  onClick,
  iconName,
  style,
}: {
  onClick: () => void;
  iconName: string;
  style?: CSSProperties;
}) {
  return (
    <Button size="xs" onClick={onClick} color={skyLighter} px={4} style={style}>
      <Icon name={iconName} size={20} style={{ cursor: 'pointer' }} />
    </Button>
  );
}

export { SmallSquareButton };
